import React from "react";

interface Doctor {
  id: number;
  name: string;
  specialty?: string;
}

interface DoctorSelectProps {
  value: number | undefined;
  onChange: (doctorId: number | undefined) => void;
  doctors: Doctor[];
  error?: string;
  required?: boolean;
}

const DoctorSelect: React.FC<DoctorSelectProps> = ({
  value,
  onChange,
  doctors,
  error,
  required = false,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const doctorId = e.target.value ? parseInt(e.target.value) : undefined;
    onChange(doctorId);
  };

  const inputStyle: React.CSSProperties = {
    width: "100%",
    padding: "14px 18px",
    border: error ? "2px solid #ef4444" : "2px solid #e5e7eb",
    borderRadius: "12px",
    fontSize: "16px",
    background: error ? "#fef2f2" : "#ffffff",
    transition: "all 0.2s ease",
    outline: "none",
  };

  return (
    <div>
      <label
        htmlFor="primaryDoctor"
        style={{
          display: "block",
          fontSize: "14px",
          fontWeight: "500",
          color: "#4b5563",
          marginBottom: "10px",
        }}
      >
        Primary Doctor {required && <span style={{ color: "#ef4444" }}>*</span>}
      </label>

      <select
        id="primaryDoctor"
        value={value || ""}
        onChange={handleChange}
        style={inputStyle}
      >
        <option value="">Select a doctor (optional)</option>
        {doctors.map((doctor) => (
          <option key={doctor.id} value={doctor.id}>
            Dr. {doctor.name} {doctor.specialty && `- ${doctor.specialty}`}
          </option>
        ))}
      </select>

      {error && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            color: "#ef4444",
            fontSize: "14px",
            marginTop: "6px",
          }}
        >
          <span style={{ marginRight: "6px" }}>⚠️</span>
          {error}
        </div>
      )}
    </div>
  );
};

export default DoctorSelect;
